// src/Settings/DatabaseAdvisor/constants.js
export const SEVERITY_ORDER = ['critical', 'error', 'warning', 'info'];

export const SEVERITY_LABELS = {
  critical: 'Critical',
  error: 'Error',
  warning: 'Warning',
  info: 'Info',
};

export const SEVERITY_COLORS = {
  critical: '#d32f2f',
  error: '#e64a19',
  warning: '#ff9800',
  info: '#757575',
};

export const ROW_STATUS_COLORS = {
  missing: '#d32f2f',
  critical: '#d32f2f',
  error: '#e64a19',
  warning: '#ff9800',
  info: '#757575',
  healthy: '#2e7d32',
};

export const ADVISOR_TABS = [
  { value: 'tables', label: 'Tables' },
  { value: 'indexes', label: 'Indexes' },
  { value: 'foreignKeys', label: 'Foreign Keys' },
];

export const TABLE_FILTER_OPTIONS = [
  { value: 'issues', label: 'Issues Only' },
  { value: 'missing', label: 'Missing' },
  { value: 'all', label: 'All' },
];

export const INDEX_FILTER_OPTIONS = [
  { value: 'missing', label: 'Missing' },
  { value: 'all', label: 'All' },
];

export const FK_FILTER_OPTIONS = [
  { value: 'missing', label: 'Missing' },
  { value: 'all', label: 'All' },
];

export const HEADER_GRADIENT = 'linear-gradient(120deg, #123a63 0%, #1f6fb2 100%)';

// CLIENT BRANCH: only the "missing" direction is ever reported (see diff.js) — no "extra" status.
export const INDEX_STATUS_DESCRIPTIONS = {
  present: 'Declared on the model and found in the database — matches as expected.',
  missing: 'Declared on the model but not found in the database.',
  healthy: 'Every model-declared index was found in the database.',
};

// CLIENT BRANCH: same rule as indexes above -- only "declared on the model but not found in the
// database" is ever reported.
export const FK_STATUS_DESCRIPTIONS = {
  present: 'Declared on the model (via an explicit reference or a belongsTo/hasMany association) and found in the database — matches as expected.',
  missing: 'Declared on the model but the database has no matching foreign key constraint.',
  healthy: 'Every model-declared foreign key was found in the database.',
};

// The summary row mixes two different units — these descriptions spell out which is which so it
// stops reading as one flat list of numbers.
export const SUMMARY_BADGE_DESCRIPTIONS = {
  missingTables:
    'Counts whole TABLES: how many tables the code expects that do not exist in the database at all.',
  critical:
    'Counts individual FINDINGS (usually one column or index) across every table, marked critical severity.',
  errors:
    'Counts individual FINDINGS (usually one column) across every table, marked error severity.',
  warnings:
    'Counts individual FINDINGS (usually one column or index) across every table, marked warning severity.',
  info: 'Counts individual FINDINGS (usually one column) across every table, marked info severity.',
};
